module.exports = __webpack_public_path__ + "img/84.e3c587f3.png";